module.exports = __webpack_public_path__ + "img/ring_y_i_1_1@2x.bb368ab8.png";